import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  filteredUsersFromApi: [],
  totalPagesCount: 1,
  initialUsersSize: 0,
  users_list: [],
};

const usersSlice = createSlice({
  name: 'users',
  initialState,
  reducers: {
    updatedTotalPagesCount(state, action) {
      state.totalPagesCount = action.payload;
    },
    reducedUsersToTheirInitialSize(state) {
      state.users_list = state.users_list.slice(0, state.initialUsersSize);
    },
    setFilteredUsersFromApi(state, action) {
      state.filteredUsersFromApi = action.payload;
    },
  },
});

export const {
  updatedTotalPagesCount,
  reducedUsersToTheirInitialSize,
  setFilteredUsersFromApi,
} = usersSlice.actions;
export default usersSlice.reducer;
